import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MomentService } from './moment.service';
import { FindDuplicatePipe } from '../pipes/find-duplicate.pipe';
import { toRoundOffUsingSubstring } from '../utils';
import { PrimengDeleteConfirmDialogComponent } from '../components/primeng-delete-confirm-dialog/primeng-delete-confirm-dialog.component';
import { DialogService } from 'primeng/api';
import { PrimengConfirmDialogPopupComponent } from '../components/primeng-confirm-dialog-popup';

const titleKey = 'titleKey';
const previousUrlKey = 'previousUrlKey';
const currentUrlKey = "currentUrlKey";
const customTitleKey = "customTitleKey";
@Injectable({ providedIn: 'root' })
export class OtherService {

  constructor(private decimalPipe: DecimalPipe, private momentService: MomentService, private findDuplicatePipe: FindDuplicatePipe,
    private dialogService: DialogService,
  ) { }

  set title(titleName: string | null) {
    if (titleName) {
      sessionStorage.setItem('title', JSON.stringify(titleName));
    }
    else {
      sessionStorage.removeItem('title');
    }
  }

  get title() {
    return JSON.parse(sessionStorage.getItem('title'));
  }

  set customTitle(titleName: string | null) {
    if (titleName) {
      sessionStorage.setItem(customTitleKey, JSON.stringify(titleName));
    }
    else {
      sessionStorage.removeItem(customTitleKey);
    }
  }

  get customTitle() {
    return JSON.parse(sessionStorage.getItem(customTitleKey));
  }

  set previousUrl(prevUrl: string | null) {
    if (prevUrl) {
      sessionStorage.setItem(previousUrlKey, JSON.stringify(prevUrl));
    }
    else {
      sessionStorage.removeItem(previousUrlKey);
    }
  }

  get previousUrl() {
    return JSON.parse(sessionStorage.getItem(previousUrlKey));
  }

  set currentUrl(currentUrl: string | null) {
    if (currentUrl) {
      sessionStorage.setItem(currentUrlKey, JSON.stringify(currentUrl));
    }
    else {
      sessionStorage.removeItem(currentUrlKey);
    }
  }

  get currentUrl() {
    return JSON.parse(sessionStorage.getItem(currentUrlKey));
  }

  transformDecimalSubstring(num: number | any) {
    if (typeof num == 'string' && num?.toString()?.indexOf('R') !== -1) {
      return num;
    }
    if (num?.toString()?.indexOf('.') !== -1 && num) {
      return 'R ' + toRoundOffUsingSubstring(num);
    }
    else if (num?.toString() && num) {
      return 'R ' + toRoundOffUsingSubstring(num);
    } else if (num == 0) {
      return `R ${num}.00`;
    } else {
      return num;
    }
  }

  //don't remove this currency format
  transformDecimal(num: number | any) {
    if (typeof num == 'string' && num?.toString()?.indexOf('R') !== -1) {
      return num;
    }
    if (num?.toString()?.indexOf('.') !== -1 && num) {
      return 'R ' + this.decimalPipe.transform(num, '.2-2', 'en-GB').toString().replace(/,/g, " ");
    }
    else if (num?.toString() && num) {
      return 'R ' + this.decimalPipe.transform(num, '.2-2', 'en-GB').toString().replace(/,/g, " ");
    } else if (num == 0) {
      return `R ${num}.00`;
    } else {
      return num;
    }
  }

  transformFourDigitDecimal(num: number | any) {
    if (typeof num == 'string' && num?.toString()?.indexOf('R') !== -1) {
      return num;
    }
    if (num?.toString()?.indexOf('.') !== -1 && num) {
      return 'R ' + this.decimalPipe.transform(num, '.4-4', 'en-GB').toString().replace(/,/g, " ");
    }
    else if (num?.toString() && num) {
      return 'R ' + this.decimalPipe.transform(num, '.4-4', 'en-GB').toString().replace(/,/g, " ");
    } else if (num == 0) {
      return `R ${num}.00`;
    } else {
      return num;
    }
  }

  transformCurrToNum(num: any) {
    if (typeof num == 'number') {
      return num;
    }
    if (num != null && num != '') {
      const number = num?.indexOf('R') != -1 ? num?.replace('R ', '') : num ? num : '';
      if (number) {
        return +(number?.replace(/ /g, ""));
      }
    } else if (num?.toString()) {
      return num;
    } else if (num == 0) {
      return num;
    }
    return num;
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    return formArray;
  };

  onCutOfTimeValidation = (val, internalCutOffTime) => {
    const todayDate = this.momentService.localToUTC(new Date());
    return this.momentService.localToUTC(val) == todayDate && this.momentService.toHoursMints24(new Date()) >= this.momentService.toHoursMints24(`${todayDate} ${internalCutOffTime}`)
  }


  findDuplicateContactNumber(formGroup: FormGroup, isGroup = true) {
    if (isGroup) {
      const mobile1Duplicate = this.findDuplicatePipe.transform(formGroup.get('customerInformationDTO.mobile1')?.value, (formGroup.controls?.customerInformationDTO as FormGroup), 'mobile1', formGroup?.get('customerInformationDTO.mobile1CountryCode')?.value);
      const mobile2Duplicate = this.findDuplicatePipe.transform(formGroup.get('customerInformationDTO.mobile2')?.value, (formGroup.controls?.customerInformationDTO as FormGroup), 'mobile2', formGroup?.get('customerInformationDTO.mobile2CountryCode')?.value);
      const premisesNoDuplicate = this.findDuplicatePipe.transform(formGroup.get('customerInformationDTO.premisesNo')?.value, (formGroup.controls?.customerInformationDTO as FormGroup), 'premisesNo', formGroup?.get('customerInformationDTO.premisesNoCountryCode')?.value);
      const officeNoDuplicate = this.findDuplicatePipe.transform(formGroup.get('customerInformationDTO.officeNo')?.value, (formGroup.controls?.customerInformationDTO as FormGroup), 'officeNo', formGroup?.get('customerInformationDTO.officeNoCountryCode')?.value);
      return mobile1Duplicate || mobile2Duplicate || premisesNoDuplicate || officeNoDuplicate;
    } else {
      const mobile1Duplicate = this.findDuplicatePipe.transform(formGroup.get('mobile1')?.value, formGroup, 'mobile1', formGroup?.get('mobile1CountryCode')?.value);
      const mobile2Duplicate = this.findDuplicatePipe.transform(formGroup.get('mobile2')?.value, formGroup, 'mobile2', formGroup?.get('mobile2CountryCode')?.value);
      const premisesNoDuplicate = this.findDuplicatePipe.transform(formGroup.get('premisesNo')?.value, formGroup, 'premisesNo', formGroup?.get('premisesNoCountryCode')?.value);
      const officeNoDuplicate = this.findDuplicatePipe.transform(formGroup.get('officeNo')?.value, formGroup, 'officeNo', formGroup?.get('officeNoCountryCode')?.value);
      return mobile1Duplicate || mobile2Duplicate || premisesNoDuplicate || officeNoDuplicate;
    }
  }

  onValidateFormByTab(profileInformationComponent: any, getContactPersontArray: any, getProfileManagerArray: any, getCdmArray: any, tabName = 'Community Name') {
    profileInformationComponent.profileInformationForm.markAsUntouched();
    if (!profileInformationComponent?.contactPersonForm?.getRawValue()?.contactPersion?.value && !profileInformationComponent?.contactPersonForm?.getRawValue()?.contactNumber?.value) {
      profileInformationComponent.contactPersonForm.markAsUntouched();
    }
    if (!profileInformationComponent?.profileManagerForm?.getRawValue()?.roleId?.value && !profileInformationComponent?.profileManagerForm?.getRawValue()?.employeeId?.value) {
      profileInformationComponent.profileManagerForm.markAsUntouched();
    }
    if (!profileInformationComponent?.cdmForm?.getRawValue()?.roleId?.value && !profileInformationComponent?.cdmForm?.getRawValue()?.employeeId?.value) {
      profileInformationComponent.cdmForm.markAsUntouched();
    }
    if (profileInformationComponent.profileInformationForm.invalid) {
      profileInformationComponent.profileInformationForm.markAllAsTouched();
      profileInformationComponent.selectTab(tabName);
    } else if (((profileInformationComponent?.contactPersonForm?.invalid && profileInformationComponent?.contactPersonForm?.touched) || (getContactPersontArray?.invalid && getContactPersontArray?.length == 1))) {
      profileInformationComponent.selectTab('Contact Person');
      profileInformationComponent.contactPersonForm.markAllAsTouched();
    } else if ((profileInformationComponent?.profileManagerForm?.invalid && profileInformationComponent?.profileManagerForm?.touched) || (getProfileManagerArray?.invalid && getProfileManagerArray?.length == 1)) {
      profileInformationComponent.selectTab('Profile Managers');
      profileInformationComponent.profileManagerForm.markAllAsTouched();
    } else if ((profileInformationComponent?.cdmForm?.invalid && profileInformationComponent?.cdmForm?.touched) || (getCdmArray?.invalid && getCdmArray?.length == 1)) {
      profileInformationComponent.selectTab('CDM');
      profileInformationComponent.cdmForm.markAllAsTouched();
    }
  }

  openDeleteConfirmPDialog(dataObj) {
    return new Promise((resolve, reject) => {
      const ref = this.dialogService.open(PrimengDeleteConfirmDialogComponent, {
        showHeader: false,
        baseZIndex: 10000,
        width: '400px',
        data: dataObj,
      });
      ref.onClose.subscribe((result) => {
        if (result) {
          resolve(result);
        } else {
          reject(result);
        }
      });
    });
  }

  openConfirmPDialog(dataObj) {
    return new Promise((resolve, reject) => {
      const ref = this.dialogService.open(PrimengConfirmDialogPopupComponent, {
        showHeader: false,
        baseZIndex: 10000,
        width: '400px',
        data: dataObj,
      });
      ref.onClose.subscribe((result) => {
        if (result) {
          resolve(result);
        } else {
          reject(result);
        }
      });
    });
  }
}
